/**
 * 拖曳
 * @param {外层盒子} oDrag 
 * @param {拖拽部分} handle 
 */
 export function dragView(oDrag, handle) {
  let disX = 0
  let disY = 0
  handle = handle || oDrag
  handle.style.cursor = 'move'
  handle.onmousedown = function (e) {
    e.preventDefault()
    disX = e.clientX - oDrag.offsetLeft
    disY = e.clientY - oDrag.offsetTop
    document.onmousemove = function (e) {
      let Left = e.clientX - disX
      let Top = e.clientY - disY
      let maxleft = document.documentElement.offsetWidth - oDrag.offsetWidth
      let maxtop = document.documentElement.clientHeight - oDrag.offsetHeight
      if (Left < 0) {
        Left = 0
      } else if (Left > maxleft) {
        Left = maxleft
      }
      if (Top < 0) {
        Top = 0
      } else if (Top > maxtop) {
        Top = maxtop
      }
      oDrag.style.left = Left + 'px'
      oDrag.style.top = Top + 'px'
    }
    document.onmouseup = function () {
      document.onmousemove = null
      document.onmouseup = null
    }
  }
}